/**
 * Display teachers script
 */
class PWSJO_Teachers {
    constructor() {
        this.initState();
        this.initEvents();
    }

    initState () {
        this.teachersWrapper = $('.teachers');
        this.selectLang = this.teachersWrapper.find('.select-language');
    }

    initEvents () {
        if (this.teachersWrapper.length) {
            this.selectLang.change(function(){
                $(this).find("option:selected").each(function() {
                    var optionValue = $(this).attr("value");

                    if(optionValue){
                        $(".teachers-list").not('[data-lang="' + optionValue + '"]').removeClass('is-active');
                        $(".teachers-list[data-lang='" + optionValue + "']").addClass('is-active');
                    } else{
                        $(".teachers-list").removeClass('is-active');
                    }
                });
            }).change();
        }
    }
}
